var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-tap-hint"},[_c('div',{staticClass:"preview-tap-hint__pill"},[_c('v-icon',{attrs:{"color":"white","size":"24"}},[_vm._v("$tap")]),_c('span',[_vm._v(_vm._s(_vm.text))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }